/**
 * Thai labels for tier_audit_log.activity, in the order the Audit Log filter lists them.
 * Single source for the filter dropdown (ShopTier/index.tsx), the Action tag and the subject
 * column, so the three can't drift apart.
 */
export const TIER_AUDIT_LOG_ACTIVITIES = [
  "MANUAL_ADJUST",
  "UPDATE_NAVISION",
  "CHANGE_REBATE_DISPLAY_POLICY",
  "CREATE_PROGRAM",
  "UPDATE_PROGRAM",
  "AUTO_PROMOTE",
  "INITIAL_TIER",
  "AUTO_DEMOTE",
  "ROLLOVER",
] as const;

export const TIER_AUDIT_LOG_ACTIVITY_LABEL: Record<string, string> = {
  MANUAL_ADJUST: "ปรับระดับระหว่างปี",
  UPDATE_NAVISION: "อัปเดต Navision",
  CREATE_PROGRAM: "สร้างชุดสิทธิประโยชน์",
  UPDATE_PROGRAM: "แก้ไขชุดสิทธิประโยชน์",
  AUTO_PROMOTE: "เลื่อนระดับอัตโนมัติ",
  INITIAL_TIER: "ระดับตั้งต้น",
  AUTO_DEMOTE: "ลดระดับอัตโนมัติ",
  ROLLOVER: "ผลพิจารณาสิ้นปี",
};

/**
 * Label for an activity code. CHANGE_REBATE_DISPLAY_POLICY names the percent the company uses
 * ("Top Up" for ICPL, "Rebate" for the others), so it needs the company.
 * Unknown codes fall back to the raw code.
 */
export function tierAuditLogActivityLabel(activity: string, company?: string | null): string {
  if (activity === "CHANGE_REBATE_DISPLAY_POLICY") {
    return `การแสดง % ${company === "ICPI" ? "Top Up" : "Rebate"}`;
  }
  return TIER_AUDIT_LOG_ACTIVITY_LABEL[activity] || activity;
}

/** Options for the Audit Log "การดำเนินการ" filter. */
export function tierAuditLogActivityOptions(company?: string | null) {
  return company === "ICPL" ? TIER_AUDIT_LOG_ACTIVITIES.filter((activity) => (activity !== "AUTO_PROMOTE" && activity !== "AUTO_DEMOTE")).map((activity) => ({
    key: activity,
    value: activity,
    label: tierAuditLogActivityLabel(activity, company),
  })) : TIER_AUDIT_LOG_ACTIVITIES.map((activity) => ({
    key: activity,
    value: activity,
    label: tierAuditLogActivityLabel(activity, company),
  }));
}
